import ServiceDetailPage from "@/components/ServiceDetailPage";

const Consulting = () => <ServiceDetailPage pageKey="consulting" />;

export default Consulting;
